import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { initDataStore } from 'src/store/taxData';
import TaxTopButton from 'src/components/organisms/template/StepC/template/TaxModal/TaxTopButton';
import TaxBottomDesc from 'src/components/organisms/template/StepC/template/TaxModal/TaxBottomDesc';
import { contentModalViewStore } from 'src/store/modal';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import GridList from './List';
import '../tableRef.scss';
import './style.scss';

interface Props {
  type: string;
  data: any;
}
const CompnyGrid: FC<Props> = ({ type, data }) => {
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  const viewData: any = data || {};
  const closeEvt = () => {
    setContentModalState({
      active: '',
    });
  };
  const help = {
    title: '파일에서 종전 근무지 정보를 자동 추출합니다.',
    content: '(근로소득 원천징수 영수증 파일 선택)',
  };
  //
  const listGrid = () => {
    return (
      <div className="_list_grid">
        {/* <TaxTopButton /> */}
        <GridList data={viewData} />
        <div className="_bottom_div">
          <div className="_btn">
            <DefaultButton
              text="확인"
              styleDef={{ width: '300px', height: '38px' }}
              clickEvent={e => closeEvt()}
              icon=""
              type="type5"
              iconStyleDef={{ fontSize: '18px' }}
            />
          </div>
        </div>
        {/* <TaxBottomDesc /> */}
      </div>
    );
  };

  return (
    <div className="_company_detail_div_layout">
      <div className="_content_div">{listGrid()}</div>
    </div>
  );
};

export default CompnyGrid;
